import { render, staticRenderFns } from "./SupplyForm.vue?vue&type=template&id=2063a556"
import script from "./SupplyForm.vue?vue&type=script&lang=js"
export * from "./SupplyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports